<template>
<div class="search-data-container">
  <div class="config-tree-area">
    <GroupTree />
  </div>
  <div class="alarm-data-area">
    <div class="search-data-header">
      <div class="search-data-query">
        {{showLang('com.cmd.source')}}：
        <Select :placeholder="showLang('save.select')" v-model="filter.source" number style="margin-right: 10px; width: 100px;">
          <Option :value="-1">{{ showLang('com.state.all') }}</Option>
          <template v-for="item in sources">
            <Option :value="item.id" :key="item.id">{{ item.name }}</Option>
          </template>
        </Select>
        {{showLang('com.ins.last.id')}}：
        <Input type="text" v-model="filter.code" clearable style="width: 150px; margin: 0 10px;"></Input>
        {{showLang('com.ins.name')}}：
        <Input type="text" v-model="filter.name" clearable style="width: 150px; margin: 0 10px;">
        </Input>
        {{showLang('com.date.start')}}：
        <DatePicker v-model="filter.start" type="datetime" style="width: 175px; margin-right: 10px;"></DatePicker>
        {{showLang('com.date.end')}}：
        <DatePicker v-model="filter.end" type="datetime" style="width: 175px; margin-right: 10px;"></DatePicker>
        <Button v-if="funCodes(7522)" type="info" :loading="loading" @click="search" style="margin-right: 10px;">{{showLang('com.op.query')}}</Button>
      </div>
    </div>
    <div class="search-data-content" ref="table1">
      <vxe-table :empty-text="showLang('com.data.no')" :loading="loading" border resizable show-overflow
        show-header-overflow keep-source ref="chkTable" :data="tabData" height="auto"
        :row-config="{isHover: true}" :checkbox-config="{checkField: 'checked',}"
        footer-cell-class-name="footer-cell-class">
        <vxe-column type="seq" width="60"></vxe-column>
        <vxe-column field="deviceName" :title="showLang('com.tab.title')" width="150" header-align="center"></vxe-column>
        <vxe-column field="groupName" title="所在分区" width="150" header-align="center"></vxe-column>
        <vxe-column field="code" :title="showLang('com.export.cn.connid')" width="150" header-align="center"></vxe-column>
        <vxe-column field="createTime" :title="showLang('com.date.Creation')" width="150" header-align="center"></vxe-column>
        <vxe-column field="sendTime" :title="showLang('com.lighting.sending.time')" width="150" header-align="center">
          <template #default="{ row }">
            {{row.sendTime==''?'-':row.sendTime}}
          </template>
        </vxe-column>
        <vxe-column field="commandName" :title="showLang('com.ins.name')" width="120" header-align="center"></vxe-column>
        <vxe-column field="sourceName" :title="showLang('com.ins.source')" width="80" header-align="center"></vxe-column>
        <vxe-column field="sendUserName" :title="showLang('com.user.send')" width="80" header-align="center"></vxe-column>
        <vxe-column field="checkUserName" :title="showLang('com.user.check')" width="80" header-align="center"></vxe-column>
        <vxe-column field="args" :title="showLang('com.parameter')" width="120" header-align="center">
          <template #default="{ row }">
            {{getCmdArgs(row)}}
          </template>
        </vxe-column>
        <vxe-column field="replyTime" :title="showLang('com.date.recovery')" width="150" header-align="center">
          <template #default="{ row }">
            {{row.status > 6 ? row.replyTime : '-'}}
          </template>
        </vxe-column>
        <vxe-column field="message" :title="showLang('com.ins.result')" header-align="center">
          <template #default="{ row }">
            {{getCmdResult(row)}}
          </template>
        </vxe-column>
      </vxe-table>
    </div>
    <vxe-pager :layouts="pageLayouts" :page-sizes='pageSizes' :current-page.sync="filter.index" :page-size.sync="filter.size" :total="count" @page-change="handlePageChange1"> </vxe-pager>
  </div>
</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import GroupTree from '../../../common/treeGroup/Index'
export default {
  name: 'StationConfigIndex',
  components: {
    GroupTree,
  },
  props: {
  },
  data() {
    return {
      loading: false,
      tabData: [],
      exportLoading: false,
      count: 0,
      filter: {
        groupId: 0,
        code: '',
        name: '',
        source: 0,
        start: "",
        end: "",
        index: 1,
        size: 20,
      },
      history: [],
      sources: [],
    }
  },
  computed: {
    ...mapGetters('auth', ['funCodes', 'showLang']),
    ...mapState('cmd', ['windowOnResize', 'cmds']),
    ...mapState('common', ['productCodes', 'pageSizes', 'pageLayouts']),
    ...mapState('group', ['groups', 'groupTreeSelectedNode']),
  },
  watch: {
    groupTreeSelectedNode() {
      this.search()
    }
  },
  mounted: function () {
    this.getSources();
    let now = new Date();
    now.setHours(now.getHours() + 1);
    this.filter.end = now.format('yyyy-MM-dd HH:mm:ss');
    now.setDate(now.getDate() - 3);
    this.filter.start = now.format('yyyy-MM-dd HH:mm:ss');
  },
  destroyed: function () {
  },
  methods: {
    getSources() {
      this.$axios.post(`station/command/QueryCommandSource`, {}).then(res => {
        if (res.code == 0) {
          this.$set(this, 'sources', res.data);
        }
      });
    },
    search: function(){
      this.filter.index = 1;
      this.getList();
    },
    handlePageChange1: function (params) {
      this.filter.index = params.currentPage
      this.filter.size = params.pageSize
      this.getList()
    },
    getList() {
      this.filter.groupId = this.groupTreeSelectedNode.id;
      this.filter.start = new Date(this.filter.start).format("yyyy-MM-dd HH:mm:ss");
      this.filter.end = new Date(this.filter.end).format("yyyy-MM-dd HH:mm:ss");
      this.loading = true;
      this.$axios.post(`station/command/QueryGatewayNew`, this.filter).then(res => {
        this.loading = false;
        if (res.code == 0) {
          this.$set(this, 'tabData', res.data.list);
          this.count = res.data.count;
        }
      });
    },
    getCmdArgs: function(cmd){
      switch(cmd.command){
        default: return '-';
      }
    },
    getCmdResult: function(cmd){
      if(cmd.status == 0)return '未执行';
      if(cmd.status != 9){
        return cmd.result.message;
      }
      switch(cmd.command){
        default: return '执行成功';
      }
    },
  }
}
</script>
<style scoped>
.config-tree-area{
  /* border: solid 1px #dcdee2; */
  width: 300px;
  flex: none;
}
.alarm-data-area {
  /* border: solid 1px red; */
  margin-left: 10px;
  border: solid 1px #dcdee2;
  width: 100px;
  flex: auto;
  /* border: solid 1px #DCDEE2; */
  /* border-radius: 6px; */
  display: flex;
  flex-direction: column;
  
  background: #fff;
}
.search-data-container {
  height: 100%;
  display: flex;
  /* flex-direction: column; */
  /* align-content: stretch; */
  /* border: solid 1px blue; */
}
.search-data-header {
  height: 40px;
  flex: none;
  display: flex;
  /* border: solid 1px blue; */
}
.search-data-content {
  height: 100px;
  flex: auto;
  /* border: solid 1px blue; */
}
.search-data-query {
  width: 830px;
  flex: auto;
  background-color: white;
  /* margin: 3px 1px; */
  display: flex;
  align-items: center;
  padding: 10px;
  /* border: solid 1px blue; */
  white-space: nowrap;
}
.search-data-view {
  width: 300px;
  flex: auto;
  display: flex;
  align-items: center;
  /* border: solid 1px blue; */
  white-space: nowrap;
  padding: 10px;
}
</style>